Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _propTypes2['default'].node.isRequired,
  inlineBlock: _propTypes2['default'].bool
}));

var defaultProps = {
  inlineBlock: false
};

/**
 * Mirror is intended to flip its content as if looking into a mirror.
 * For example, a IconStarHalf will be filled on the other side.
 */

function Mirror(_ref) {
  var css = _ref.css,
      children = _ref.children,
      inlineBlock = _ref.inlineBlock,
      styles = _ref.styles;

  var Element = inlineBlock ? 'span' : 'div';
  return _react2['default'].createElement(
    Element,
    css(styles.container, inlineBlock && styles.container_inlineBlock),
    children
  );
}

Mirror.componentCategory = 'Private';
Mirror.displayName = 'Mirror';
Mirror.propTypes = propTypes;
Mirror.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    container: {
      transform: 'scaleX(-1)'
    },

    container_inlineBlock: {
      // the scaleX transform only works on block or inline-block elements
      display: 'inline-block',
      verticalAlign: 'top'
    }
  };
})(Mirror);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/Mirror.js
// module id = 153
// module chunks = 923280921217 19843951674672